<template>
    <div class="hint-container">
        <div class="hint row">
            <div class="col-md-2 col-sm-11 d-flex text-center">
                <img class="justify-content-center align-self-center" alt="icon" :src="imgSrc">
            </div>
            <div class="col-md-10 col-sm-11 justify-content-center align-self-center">
                <h5 class="title" v-html="title" :style="style"></h5>
                <div class="content" :style="style">
                    <slot name="content"/>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

    export default {
        props: {
            title: String,
            imgSrc: String,
            textColor: String
        },
        computed: {
            style () {
                return 'color: ' + this.textColor;
            }
        }
    }
</script>
<style scoped lang="scss">

    @import "../../sass/variables";

    .title, .content {
        font-size: 1rem;
    }

    img {
        max-width: 100px;
        width: 100%;
        margin: 2rem auto;
    }

    .content {
        font-weight: 300;
    }

    .title, .content {
        text-align: left;
    }
</style>
